import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'


interface Options {
  shiftId: string,
  serialId: number,
}
export const apiMobileAssetPrestartsByShiftId = ({
  shiftId,
  serialId,
}: Options) => {
  const data = {
  }
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/v2/map/summary`,
    data,
    params: {
      shift: shiftId,
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(options)
}